class NoopSpan {
    setAttribute(_name, _value) { }
    addEvent(_name, _attributes) { }
    incrementCounter(_name, _delta) { }
    end(_error) { }
}
const noopSpan = new NoopSpan();
export class NoopInstrumentation {
    run(_name, fn, _options) {
        return fn(noopSpan);
    }
    async runAsync(_name, fn, _options) {
        return await fn(noopSpan);
    }
    startSpan(_name, _options) {
        return noopSpan;
    }
}
export const noopInstrumentation = new NoopInstrumentation();
//# sourceMappingURL=noop.js.map